'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.systemReportError = systemReportError;
exports.systemCleanError = systemCleanError;
var SYSTEM_REPORT_ERROR = exports.SYSTEM_REPORT_ERROR = '@@system/REPORT_ERROR';
var SYSTEM_CLEAN_ERROR = exports.SYSTEM_CLEAN_ERROR = '@@system/CLEAN_ERROR';

function systemReportError(error) {
  return {
    type: SYSTEM_REPORT_ERROR,
    payload: error
  };
}

function systemCleanError() {
  return {
    type: SYSTEM_CLEAN_ERROR
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/kryfe-lib/es/actions/systemError.js
// module id = vLju
// module chunks = 4